import React from "react";
import styled from "styled-components";
import { useMeasure } from "react-use";
import { AccountWidget } from "../../../components/openAccountWidget/accountWidget";

const HeightMeasure = styled.div`
  visibility: hidden;
  flex: 1;
`;

export const CutAccountWidget = ({ account }) => {
  const [ref, { height }] = useMeasure();

  return (
    <AccountWidget account={account} style={{ marginBottom: `-${height}px` }}>
      <HeightMeasure ref={ref} />
    </AccountWidget>
  );
};